<!-- Toast Boxes -->
<!--
        toast-box names:-
        *** toast-success | toast-error | toast-warning | toast-info
     -->
<div class="toast-box toast-{{this.messageType}}" *ngIf="message">
  <div class="msg">{{ message.text }}</div>
</div>